import React, { useEffect, useState, useRef } from "react";
import style from "./Activity.module.css";
import { baseurl } from "../Url";
import { useLocation, useNavigate } from "react-router-dom";
import { FaBookOpen, FaUpload, FaFileAlt, FaVideo, FaImage } from "react-icons/fa";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Loader from "../Loder/Loader";
import ChatPopup from "../ChatPopup/ChatPopup";
import { BsRobot } from "react-icons/bs";
import { IoChevronBack } from "react-icons/io5";
import LearningBottomNav from "../LearningBottomNav/LearningBottomNav";
import { useLearning } from "../Context/LearningContext";

const formatUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${baseurl}/${url}`;
};

const SUBMISSION_FILE_ACCEPT =
  ".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png,text/plain";

const SUBMISSION_ALLOWED_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "jpg",
  "jpeg",
  "png",
  "txt",
]);

const SUBMISSION_ALLOWED_MIMES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "text/plain",
]);

function isAllowedSubmissionFile(file) {
  if (!file || !(file instanceof File)) return false;
  const parts = file.name.split(".");
  const ext = parts.length > 1 ? parts.pop().toLowerCase() : "";
  if (ext && SUBMISSION_ALLOWED_EXTENSIONS.has(ext)) return true;
  if (file.type && SUBMISSION_ALLOWED_MIMES.has(file.type)) return true;
  return false;
}

function Activity() {
  const location = useLocation();
  const navigate = useNavigate();
  const context = useLearning();
  const learningData = context?.learningData || {};

  const [activeTaskIndex, setActiveTaskIndex] = useState(0);
  const [activeContentIndex, setActiveContentIndex] = useState(0);
  const [activityDetails, setActivityDetails] = useState([]);
  const key = JSON.parse(localStorage.getItem("access-token"));
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const main_topic_id = localStorage.getItem("main_topic_id");
  const UserName = localStorage.getItem("username");
  const [activityComments, setActivityComments] = useState({});
  const [aiID, setAiID] = useState(null);
  const [isChatPopupVisible, setChatPopupVisible] = useState(false);
  const [file, setFile] = useState(null);
  const [singleTopic, setSingleTopic] = useState(null);
  const [learningID, setLearningID] = useState(null);
  const [uniqueId, setUniqueId] = useState(null);
  const [topicNo, setTopicNo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [roomID, setRoomID] = useState(false);
  const [comment, setComment] = useState(false);
  const [mappedLessons, setMappedLessons] = useState(null);
  const [assessmentExist, setAssessmentExist] = useState(false);
  const [assessmentInfo, setAssessmentInfo] = useState(null);
  const [mainTopicID, setMainTopicID] = useState(null);
  const [showTaskContent, setShowTaskContent] = useState(false);
  const [taskDocId, setTaskDocId] = useState(null);
  const [userSubmissions, setUserSubmissions] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [submissionData, setSubmissionData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFinishing, setIsFinishing] = useState(false);
  const [isTopicAlreadyComplete, setIsTopicAlreadyComplete] = useState(false);

  async function checkTopicStatus() {
    if (!USERID || !singleTopic?.id || !learningID) return;
    try {
      const resp = await fetch(`${baseurl}/userlearning/details/individual`, {
        method: "POST",
        body: JSON.stringify({
          userlearning_id: learningID,
          user_id: USERID
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await resp.json();
      if (data.status === true && data.data?.[0]?.Topics) {
        let foundComplete = false;
        for (const module of data.data[0].Topics) {
          const topic = module.topics.find(t => t.id === singleTopic.id);
          if (topic && topic.status === "complete") {
            foundComplete = true;
            break;
          }
        }
        setIsTopicAlreadyComplete(foundComplete);
      }
    } catch (error) {
      console.error("Error checking topic status:", error);
    }
  }

  useEffect(() => {
    if (singleTopic && learningID) {
      checkTopicStatus();
    }
  }, [singleTopic, learningID]);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openChatPopup = () => setChatPopupVisible(true);
  const closeChatPopup = () => setChatPopupVisible(false);

  const toggleMobileView = () => setShowTaskContent(!showTaskContent);

  const commentEditorChange = (event, editor, activityId) => {
    const data = editor.getData();
    setActivityComments((prevComments) => ({
      ...prevComments,
      [activityId]: data,
    }));
  };

  const commentDivRef = useRef(null);
  useEffect(() => {
    if (comment && commentDivRef.current) {
      commentDivRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [comment]);

  async function activityGet() {
    if (!singleTopic || !singleTopic.id) return;
    setLoading(true);
    try {
      const response = await fetch(`${baseurl}/task/list/all`, {
        method: "POST",
        body: JSON.stringify({
          org_id: OrgID,
          topic_id: singleTopic.id,
          ai_id: aiID,
          user_id: USERID,
          main_topic_id: mainTopicID,
          learning_id: learningID,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await response.json();
      setActivityDetails(data.data.tasks || []);
      if (data.data.id) {
        setTaskDocId(data.data.id);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching activity data:", error);
      setActivityDetails([]);
      setLoading(false);
    }
  }

  async function fetchSubmissions() {
    if (!USERID || !taskDocId) return;
    try {
      const response = await fetch(`${baseurl}/task/submission/view`, {
        method: "POST",
        body: JSON.stringify({ user_id: USERID, task_doc_id: taskDocId }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await response.json();
      if (data.status === true && data.data) {
        setUserSubmissions(data.data.submissions || []);
      }
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  }

  useEffect(() => {
    if (taskDocId) {
      fetchSubmissions();
    }
  }, [taskDocId]);

  async function commentAdd(activityid, contentid, commentText) {
    const formData = new FormData();
    formData.append("activity_id", activityid);
    formData.append("content_id", contentid);
    formData.append("content", commentText);
    formData.append("created_by_id", USERID);
    formData.append("created_by_name", UserName);
    formData.append("file", file);

    try {
      const response = await fetch(`${baseurl}/comment/add`, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${key}` },
      });
      const data = await response.json();
      if (data.status === true) {
        activityGet();
        setActivityComments((prev) => ({ ...prev, [contentid]: "" }));
      }
    } catch (error) {
      console.error("Error while posting comment:", error);
    }
  }

  useEffect(() => {
    if (location.state || learningData?.singleTopic) {
      setAiID(location.state?.aiID !== undefined ? location.state.aiID : learningData?.aiID);
      setSingleTopic(location.state?.singleTopic || learningData?.singleTopic);
      setMappedLessons(location.state?.mapped !== undefined ? location.state.mapped : learningData?.mapped);
      setLearningID(location.state?.learning || learningData?.learning);
      setMainTopicID(location.state?.mainID !== undefined ? location.state.mainID : learningData?.mainID);
      setTopicNo(location.state?.topicNo !== undefined ? location.state.topicNo : learningData?.topicNo);
      setUniqueId(location.state?.uniqueId !== undefined ? location.state.uniqueId : learningData?.uniqueId);
      setRoomID(location.state?.roomID !== undefined ? location.state.roomID : learningData?.roomID);
      setAssessmentExist(location.state?.assessmentExist !== undefined ? location.state.assessmentExist : learningData?.assessmentExist);
      setAssessmentInfo(location.state?.assessmentInfo !== undefined ? location.state.assessmentInfo : learningData?.assessmentInfo);
    }
  }, [location.state, learningData]);
  

  useEffect(() => {
    if (singleTopic && learningID) {
      activityGet();
    }
  }, [aiID, singleTopic, learningID, mainTopicID]);

  const handleNext = async () => {
    const currentTask = activityDetails[activeTaskIndex];

    // Check if clicking "Finish Line"
    if (activeTaskIndex === activityDetails.length - 1 && activeContentIndex === currentTask?.task_content?.length - 1) {
      handleFinish();
      return;
    }

    if (activeContentIndex < currentTask.task_content.length - 1) {
      setActiveContentIndex(activeContentIndex + 1);
    } else if (activeTaskIndex < activityDetails.length - 1) {
      setActiveTaskIndex(activeTaskIndex + 1);
      setActiveContentIndex(0);
    }
  };

  const handleFinish = async () => {
    setIsFinishing(true);
    try {
      // 1. Mark as finished in backend
      const finishResp = await fetch(`${baseurl}/task/finish`, {
        method: "POST",
        body: JSON.stringify({
          user_id: USERID,
          org_id: OrgID,
          topic_id: singleTopic.id,
          main_topic_id: mainTopicID,
          learning_id: learningID,
          task_doc_id: taskDocId
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`
        }
      });
      const finishData = await finishResp.json();

      if (finishData.status === true) {
        // 2. Fetch AI Summary
        const summaryResp = await fetch(`${baseurl}/task/finish/summary`, {
          method: "POST",
          body: JSON.stringify({
            user_id: USERID,
            task_doc_id: taskDocId
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${key}`
          }
        });
        const summaryData = await summaryResp.json();
        const summary = summaryData.status === true ? summaryData.summary : "Congratulations on completing your tasks!";

        // 3. Navigate to completion page
        navigate("/task/completion", {
          state: {
            summary,
            courseName: singleTopic?.value
          }
        });
      } else {
        alert(finishData.description || "Failed to finish task. Please ensure all required fields are submitted.");
      }
    } catch (error) {
      console.error("Error during finish:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsFinishing(false);
    }
  };

  const checkFinishEnabled = () => {
    if (!activityDetails || activityDetails.length === 0) return false;

    // Check every task and every content item for required fields
    for (let t_idx = 0; t_idx < activityDetails.length; t_idx++) {
      const task = activityDetails[t_idx];
      for (let c_idx = 0; c_idx < task.task_content?.length; c_idx++) {
        const content = task.task_content[c_idx];
        const fields = content.submission_fields || [];

        for (const field of fields) {
          if (field.required) {
            // Check if this specific field has an entry in userSubmissions
            const hasSub = userSubmissions.some(s =>
              s.task_index === t_idx &&
              s.content_index === c_idx &&
              (s.answers?.[field.id] || s.answers?.[String(field.id)])
            );
            if (!hasSub) return false;
          }
        }
      }
    }
    return true;
  };

  const isFinishEnabled = checkFinishEnabled();

  const handleInputChange = (contentIndex, fieldId, value) => {
    setSubmissionData(prev => ({
      ...prev,
      [contentIndex]: {
        ...(prev[contentIndex] || {}),
        [fieldId]: value
      }
    }));
  };

  const handleFileChange = (contentIndex, fieldId, file, inputEl) => {
    if (file && !isAllowedSubmissionFile(file)) {
      alert(
        "Only these file types are allowed: .pdf, .doc, .docx, .jpg, .jpeg, .png, .txt"
      );
      if (inputEl) inputEl.value = "";
      return;
    }
    setSubmissionData((prev) => ({
      ...prev,
      [contentIndex]: {
        ...(prev[contentIndex] || {}),
        [fieldId]: file,
      },
    }));
  };

  const handleSubmission = async (contentIndex, submissionFields) => {
    const data = submissionData[contentIndex] || {};

    // Simple validation
    const missingFields = submissionFields.filter(f => f.required && !data[f.id]);
    if (missingFields.length > 0) {
      alert(`Please fill in all required fields: ${missingFields.map(f => f.label).join(", ")}`);
      return;
    }

    const invalidFileField = submissionFields.find(
      (f) =>
        f.type === "file" &&
        data[f.id] instanceof File &&
        !isAllowedSubmissionFile(data[f.id])
    );
    if (invalidFileField) {
      alert(
        `Invalid file for "${invalidFileField.label}". Allowed: .pdf, .doc, .docx, .jpg, .jpeg, .png, .txt`
      );
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("user_id", USERID);
    formData.append("org_id", OrgID);
    formData.append("topic_id", singleTopic.id);
    formData.append("task_doc_id", taskDocId);
    formData.append("task_index", activeTaskIndex);
    formData.append("content_index", contentIndex);

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    try {
      const response = await fetch(`${baseurl}/task/submit`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${key}`,
        },
      });
      const result = await response.json();
      if (result.status === true) {
        alert("Submission successful!");
        fetchSubmissions(); // Refresh submissions
        setSubmissionData((prev) => {
          const newState = { ...prev };
          delete newState[contentIndex];
          return newState;
        });
      } else {
        alert(`Submission failed: ${result.description}`);
      }
    } catch (error) {
      console.error("Submission failed:", error);
      alert("An error occurred during submission.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderSubmissionFields = (fields, contentIndex, totalMark) => {
    if (!fields || fields.length === 0) return null;

    const existingSubmission = userSubmissions.find(
      (s) => s.task_index === activeTaskIndex && s.content_index === contentIndex
    );

    const totalMarkInt =
      totalMark === null || totalMark === undefined || totalMark === ""
        ? null
        : parseInt(Number(totalMark), 10);
    const scoredMarkInt =
      existingSubmission?.marks_obtained === null ||
      existingSubmission?.marks_obtained === undefined ||
      existingSubmission?.marks_obtained === ""
        ? null
        : parseInt(Number(existingSubmission.marks_obtained), 10);
    const showScoredMark =
      existingSubmission?.evaluated === true && Number.isFinite(scoredMarkInt);

    return (
      <div className={style.submissionSection}>
        <div className={style.submissionHeaderRow}>
          <h3 className={style.submissionTitle}>
            {existingSubmission ? "Your Submitted Response" : "Your Submission"}
          </h3>
          {Number.isFinite(totalMarkInt) ? (
            <div className={style.submissionMarksCard} aria-label="Submission marks">
              <div className={style.submissionMarksRow}>
                <span className={style.submissionMarksLabel}>Total mark</span>
                <span className={style.submissionMarksValue}>{totalMarkInt}</span>
              </div>
              {showScoredMark ? (
                <div className={style.submissionMarksRow}>
                  <span className={style.submissionMarksLabel}>Mark scored</span>
                  <span className={style.submissionMarksValuePrimary}>{scoredMarkInt}</span>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
        {fields.map((field) => {
          const submittedValue = existingSubmission?.answers?.[field.id];

          return (
            <div key={field.id} className={style.fieldGroup}>
              <label className={style.fieldLabel}>
                {field.label} {field.required && !existingSubmission && <span>*</span>}
              </label>

              {existingSubmission ? (
                <div className={style.submittedResult}>
                  {field.type === "textarea" ? (
                    <p className={style.resultText}>{submittedValue || "No response provided"}</p>
                  ) : field.type === "file" ? (
                    submittedValue ? (
                      <a
                        href={formatUrl(submittedValue)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={style.resultFileLink}
                      >
                        <FaFileAlt /> View Submitted File
                      </a>
                    ) : (
                      <p className={style.resultText}>No file uploaded</p>
                    )
                  ) : null}
                </div>
              ) : field.type === "textarea" ? (
                <textarea
                  className={style.textareaField}
                  placeholder="Enter your response here..."
                  value={submissionData[contentIndex]?.[field.id] || ""}
                  onChange={(e) => handleInputChange(contentIndex, field.id, e.target.value)}
                />
              ) : field.type === "file" ? (
                <div className={style.fileInputField}>
                  <input
                    type="file"
                    id={`file-${field.id}`}
                    accept={SUBMISSION_FILE_ACCEPT}
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileChange(
                        contentIndex,
                        field.id,
                        e.target.files?.[0],
                        e.target
                      )
                    }
                  />
                  <label htmlFor={`file-${field.id}`} className={style.fileInputLabel}>
                    <FaUpload />
                    <span>
                      {submissionData[contentIndex]?.[field.id]?.name ||
                        "Click to upload or drag and drop"}
                    </span>
                  </label>
                  <p className={style.fileTypeHint}>
                    PDF, Word (.doc, .docx), images (.jpg, .jpeg, .png), or .txt only
                  </p>
                </div>
              ) : null}
            </div>
          );
        })}

        {!existingSubmission && (
          <div className={style.submitBtnContainer}>
            <button
              className={style.submitButton}
              onClick={() => handleSubmission(contentIndex, fields)}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Response"}
            </button>
          </div>
        )}
      </div>
    );
  };

  const renderContent = (content) => {
    if (!content) return null;

    return (
      <div className={style.contentWrapper}>
        <h1 className={style.taskMainTitle}>{content.title}</h1>

        <div className={style.taskIntroduction}>
          {content.blocks ? (
            content.blocks.map((block, idx) => (
              <div key={idx} className={style.contentBlock}>
                {block.type === "text" ? (
                  <div dangerouslySetInnerHTML={{ __html: block.value }}></div>
                ) : block.type === "image" ? (
                  <div className={style.imageBlock}>
                    <img src={formatUrl(block.file || block.value)} alt="Content" />
                  </div>
                ) : block.type === "video" ? (
                  <div className={style.videoBlock}>
                    <video controls>
                      <source src={formatUrl(block.file || block.value)} type="video/mp4" />
                    </video>
                  </div>
                ) : block.type === "file" ? (
                  <a href={formatUrl(block.file || block.value)} className={style.fileBlock} target="_blank" rel="noopener noreferrer">
                    <FaFileAlt />
                    <span>Download Resource</span>
                  </a>
                ) : null}
              </div>
            ))
          ) : (
            // Fallback for old structure
            <div>
              {content.type === "url" ? (
                <a href={formatUrl(content.text)} target="_blank" rel="noopener noreferrer">{content.text}</a>
              ) : content.type === "video" ? (
                <video controls width="100%" height="auto">
                  <source src={formatUrl(content.text)} type="video/mp4" />
                </video>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: content.text || content.content?.[0]?.content }}></div>
              )}
            </div>
          )}
        </div>

        {renderSubmissionFields(
          content.submission_fields,
          content.index,
          content.total_mark
        )}
      </div>
    );
  };

  return (
    <div className={style.container}>
      {(!isMobile || !showTaskContent) && (
        <div className={style.header}>
          <button className={style.backButton} onClick={() => navigate(-1)}>
            <IoChevronBack />
          </button>
          <h4 className={style.actHead}>Tasks : {singleTopic?.value || "Tasks"}</h4>
        </div>
      )}

      <div className={style.pageLayout}>
        <div className={`${style.sidebar} ${isMobile && showTaskContent ? style.hidden : ""}`}>
          <div className={style.taskList}>
            {activityDetails.map((task, index) => (
              <div
                key={index}
                className={`${style.taskItem} ${activeTaskIndex === index ? style.activeTask : ""}`}
                onClick={() => {
                  setActiveTaskIndex(index);
                  setActiveContentIndex(0);
                  if (isMobile) setShowTaskContent(true);
                }}
              >
                <div className={style.taskMarker}>{index + 1}</div>
                <div className={style.taskInfo}>
                  <p className={style.taskTitleMain}>{task.task_title}</p>
                  <div className={style.taskMeta}>
                    <span>{task.task_description}</span>
                  </div>
                </div>
              </div>
            ))}
            <div className={style.taskItem}>
              <div className={style.taskMarker}>⚐</div>
              <div className={style.taskInfo}>
                <p className={style.taskTitleMain}>Finish Line</p>
              </div>
            </div>
          </div>
        </div>

        <div className={`${style.contentArea} ${isMobile && !showTaskContent ? style.hidden : ""}`}>
          <div className={style.rightTopHeader}>
            {isMobile && (
              <button className={style.mobileBackButton} onClick={() => setShowTaskContent(false)}>
                <IoChevronBack />  <span>Task {activeTaskIndex + 1}: {activityDetails[activeTaskIndex]?.task_title}</span>
              </button>
            )}

            <div className={style.paginationBullets}>
              {activityDetails[activeTaskIndex]?.task_content?.map((_, idx) => (
                <div
                  key={idx}
                  className={`${style.bullet} ${activeContentIndex === idx ? style.activeBullet : ""}`}
                  onClick={() => setActiveContentIndex(idx)}
                >
                  {idx + 1}
                </div>
              ))}
            </div>
          </div>

          <div className={style.ActivityBody}>
            {loading ? (
              <div className={style.loaderContainer}><Loader /></div>
            ) : activityDetails.length > 0 ? (
              renderContent(activityDetails[activeTaskIndex].task_content[activeContentIndex])
            ) : (
              <p>No activity content available.</p>
            )}
          </div>

          <div className={style.contentFooter}>
            <button
              className={style.primaryButton}
              onClick={isTopicAlreadyComplete ? () => navigate(-1) : handleNext}
              disabled={
                isFinishing ||
                (!isTopicAlreadyComplete &&
                  activeTaskIndex === activityDetails.length - 1 &&
                  activeContentIndex === activityDetails[activeTaskIndex]?.task_content?.length - 1 &&
                  !isFinishEnabled)
              }
            >
              {isFinishing ? "Processing..." :
                isTopicAlreadyComplete ? "Back to Lessons" :
                  (activeTaskIndex === activityDetails.length - 1 && activeContentIndex === activityDetails[activeTaskIndex]?.task_content?.length - 1)
                    ? "Finish Task"
                    : "Next"}
            </button>
          </div>
        </div>
      </div>

      <div className={style.chatIconWrapper}>
        <div className={style.chatBox} onClick={openChatPopup}>
          <BsRobot />
        </div>
      </div>

      {isChatPopupVisible && (
        <ChatPopup
          token={key}
          setChatIcon={closeChatPopup}
          aiID={aiID}
          singleTopic={singleTopic}
          mainID={main_topic_id}
          topicNo={topicNo}
          roomID={roomID}
        />
      )}

      <LearningBottomNav
        aiID={aiID}
        singleTopic={singleTopic}
        mapped={mappedLessons}
        learning={learningID}
        mainID={mainTopicID}
        topicNo={topicNo}
        uniqueId={uniqueId}
        roomID={roomID}
        assessmentExist={assessmentExist}
        assessmentInfo={assessmentInfo}
      />
    </div>
  );
}

export default Activity;
